<script lang="ts" setup>
    import { reactive, ref } from 'vue';
    import {PageTitle} from '../../LibMain';
    import RecallSearch from "./RecallSearch.vue";
    import RecallSetup from "./RecallSetup.vue";
    import ModalDialog from '../../components/ModalDialog.vue'
    import { IRecallStatusItem, IRecallPrimaryIdentifierItem, IRecallResourceItem, IRecallAppointmentTypeItem } from '../../lib/Models/RecallModel';
    import { ILetterTemplateItem } from '../../lib/Models/LetterTemplateModel';
    import { IRowSelection } from "../../lib/ChoiceTableHelpers";
    import { AppScreens } from '../../Enums/ChoiceEnums';

    const formData = reactive<{
        displayRecallSetup: boolean,
    }>({
        displayRecallSetup: false
    });

    const Setup = ref();
    const Search = ref();

    const props = withDefaults(defineProps<{ 
        statusList: IRecallStatusItem[],
        primaryIdentifierList: IRecallPrimaryIdentifierItem[],
        resourceList: IRecallResourceItem[],
        appointmentTypeList: IRecallAppointmentTypeItem[],
        letterSchedulerList: ILetterTemplateItem[]
    }>(),
    { 
    });

    function onRecallSearchItemClick(rowData?: IRowSelection ) {
        formData.displayRecallSetup = true;
        let currentRowData = (rowData as any);
        Setup.value.loadSetup(currentRowData?.recallReminderId);
    }

    function onRecallSetupSaveClick(recallReminderId: number) {
        formData.displayRecallSetup = false;
        Search.value.refreshSearchItem(recallReminderId);
    }
</script>
<template>
    <PageTitle :security-screen-name="AppScreens.RecallSearch">
        <template #permitted>
            <RecallSearch
                ref="Search"
                :statusList="props.statusList" 
                :primaryIdentifierList="props.primaryIdentifierList"
                :resourceList="props.resourceList"
                :letterSchedulerList="props.letterSchedulerList"
                @onRecallSearchItemClick="onRecallSearchItemClick">
            </RecallSearch> 
        </template>
    </PageTitle>

    <ModalDialog v-model:show="formData.displayRecallSetup" :closeOnClickOutside=false>
        <template #title>Recall Setup</template>
        <RecallSetup 
            ref="Setup"
            :statusList="props.statusList"
            :resourceList="props.resourceList"
            :appointmentTypeList="props.appointmentTypeList"
            @onRecallSetupSaveClick="onRecallSetupSaveClick">
        </RecallSetup>
    </ModalDialog>
</template>